import { Deserializable } from '../../deserializable';

/**
 * Used for reset password requests
 */
export class ResetPasswordRequestDTO extends Deserializable {
  /**
   * @constructor
   */
  constructor(public email: string, public recaptchaResponse: string) {
    super();
  }
}
